export default __webpack_public_path__ + "assets/audios/ca6dc85ac073a0d7da0ccf4ba4aab461.mp3";